import { render, staticRenderFns } from "./cFooter.vue?vue&type=template&id=1f2366d2&scoped=true&"
import script from "./cFooter.vue?vue&type=script&lang=js&"
export * from "./cFooter.vue?vue&type=script&lang=js&"
import style0 from "./cFooter.vue?vue&type=style&index=0&id=1f2366d2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2366d2",
  null
  
)

export default component.exports